import {
  datasource_v2_sources_path,
  datasource_v2_datasources_path,
  datasource_v2_ssrm_path,
  datasource_v2_create_datasource_path,
  datasource_v2_schema_path,
  datasource_v2_refresh_path,
  datasource_v2_update_widget_settings_path,
  datasource_v2_query_path,
} from '~/routes';

// Datasource v2 endpoints (DatasourceV2Controller). 4XX/5XX responses reject with { status, body };
// 202 resolves with { status: 'loading' } while the data loads.
// Route helpers need _options: true, otherwise js-routes reads the object as a positional param.
async function request(path, { method = 'GET', body } = {}) {
  const response = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
    },
    ...(body !== undefined && { body: JSON.stringify(body) }),
  });
  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    return Promise.reject({ status: response.status, body: json });
  }
  return json;
}

export const fetchSources = (dashboardId) => (
  request(datasource_v2_sources_path({ id: dashboardId, _options: true }))
);

// Datasources for the Source select: { in_dashboard: [...], others: [...] }
export const fetchDashboardDatasources = (dashboardId) => (
  request(datasource_v2_datasources_path({ id: dashboardId, _options: true }))
);

export const findOrCreateDatasource = (dashboardId, { kind, sourceId }) => (
  request(datasource_v2_create_datasource_path({ id: dashboardId, _options: true }), {
    method: 'POST',
    body: { kind, source_id: sourceId },
  })
);

export const fetchSchema = (dashboardId, datasourceId) => (
  request(datasource_v2_schema_path({ id: dashboardId, datasource_id: datasourceId, _options: true }))
);

export const refreshDatasource = (dashboardId, datasourceId) => (
  request(datasource_v2_refresh_path({ id: dashboardId, datasource_id: datasourceId, _options: true }), { method: 'POST' })
);

export const saveWidgetQuery = (dashboardId, widgetId, { datasourceId, query }) => (
  request(datasource_v2_update_widget_settings_path({ id: dashboardId, widget_id: widgetId, _options: true }), {
    method: 'POST',
    body: { datasource_id: datasourceId, query },
  })
);

// Runs the widget's saved query; runtime holds the viewer side filter/sort/page overrides
export const queryWidget = (dashboardId, widgetId, { runtime }) => (
  request(datasource_v2_query_path({ id: dashboardId, widget_id: widgetId, _options: true }), {
    method: 'POST',
    body: { runtime },
  })
);

// AG Grid server-side row model request for the dialog grids (editors only). baseFilter is
// applied below the grid's own filter, e.g. the widget filter while editing the grouping.
export const ssrmQuery = (dashboardId, widgetId, { datasourceId, baseFilter, request: gridRequest }) => (
  request(datasource_v2_ssrm_path({ id: dashboardId, widget_id: widgetId, _options: true }), {
    method: 'POST',
    body: { datasource_id: datasourceId, base_filter: baseFilter, request: gridRequest },
  })
);
